import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
import { ItemFragment } from '../../fragments/itemFragments';
var ItemProductQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query ItemProductQuery($itemId: ID!) {\n    item(id: $itemId) {\n      ...ItemFragment\n    }\n  }\n  ", "\n"])), ItemFragment);
export default ItemProductQuery;